import React, { useState } from "react";
import "../styles/AdminDashboard.css";
import { useNavigate } from "react-router-dom";
import Register from "../Components/Register.js";
import LeaveManagement from "../Components/LeaveManagement.js";
import CreateAccount from "../Components/CreateAccount.js";
import Message from "../Components/Message.js";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { useEffect } from "react";
import Location from "../Components/Location.js";
import Viewonlyhotel from "../Components/Viewonlyhotel";
import Useraccount from "../Components/Useraccount.js";
import Lregister from "../Components/Lregister.js";
import Txtaccount from "../Sarathchandra_Textile/txtaccount.js";
import Register1 from "../Sarathchandra_Textile/register1.js";  
import Locationtxt from "../Sarathchandra_Textile/locationtxt.js";


const Txtadmin = () => {
  const [activeTab, setActiveTab] = useState("register");
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/"); // Redirect to login page
  };

  const renderContent = () => {
  switch (activeTab) {
    case "register1":
      return <Register1 />;
    case "leave":
      return <LeaveManagement />;
    case "txtaccount":
      return <Txtaccount />;
    // case "viewonlyhotel":
    //   return <Viewonlyhotel />;
    case "locationtxt":
      return <Locationtxt />;
    // case "user":
    //   return <UserDashboard />;
    default:
      return null;
  }
};

  const useLeaveNotifications = () => {
  const [newRequests, setNewRequests] = useState([]);

  useEffect(() => {
    const q = query(collection(db, "leaveRequests"), where("status", "==", "pending"));
    const unsub = onSnapshot(q, (snapshot) => {
      const requests = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setNewRequests(requests);
    });

    return () => unsub();
  }, []);

  return newRequests;
};

  return (

    <div className="admin-background"> 
      {/* <video autoPlay muted loop className="background-video">
        <source src="/admin1.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video> */} 

      {/* Logout Button at Top-Left */} 
     

    <div className="admin-dashboard"> 
     
      <header className="admin-header"> 
        
        <nav className="admin-nav"> 

         <div className="yellow-grid">

          <button
            className={activeTab === "register1" ? "active" : ""} 
            onClick={() => setActiveTab("register1")} 
          >
            REGISTER
          </button>
          {/* <button
            className={activeTab === "leave" ? "active" : ""}
            onClick={() => setActiveTab("leave")}
          >
            ROOM
          </button> */}
          <button
            className={activeTab === "txtaccount" ? "active" : ""}
            onClick={() => setActiveTab("txtaccount")}
          >
            ACCOUNT
          </button>

          <button
            className={activeTab === "locationtxt" ? "active" : ""}
            onClick={() => setActiveTab("locationtxt")}
          >
            LOCATION
          </button>

          </div>
         
        </nav>
      </header>

      <main className="admin-content">{renderContent()}</main>
    </div>
    </div>
  );
};

export default Txtadmin;
